import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";
import { useToast } from "vue-toastification";
import { DeleteMarcaVehiculoAction } from "../../actions/marcaVehiculosActions";

const toast = useToast();

export function useMarcaVehiculoDelete(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para eliminar la marca de vehÃ­culo
  const mutation = useMutation({
    mutationFn: (marcaId: string) => DeleteMarcaVehiculoAction(marcaId),

    onSuccess: async (response: ApiResponse<MarcaVehiculoInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["MarcaVehiculosList"] });
      await queryClient.refetchQueries({
        queryKey: ["MarcaModeloList"],
        exact: true,
      });
      toast.success("La marca de vehÃ­culo fue eliminada correctamente");
      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al eliminar la marca de vehÃ­culo");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
